import React, { useState, useEffect } from "react";
import TableNoBorder from "../../../../components/tables/TableNoBorder";
import EditButton from "../../../../components/EditButton";
import CancelButton from "../../../../components/CancelButton";
import SaveButton from "../../../../components/SaveButton";
import DeleteButton from "../../../../components/DeleteButton";
import TextInput from "../../../../components/TextInput";
import {
  addAgentRecord,
  deleteAgentRecord,
  updateAgentRecord,
} from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";
import { toast } from "../../../../components/toastNotification";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { getAgentRecord as getAORs } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings/index";
import { OFFICE_PERMISSIONS } from "../permission";

const AgentRecordTable = ({ data, officeId = 0 }) => {
  const [tableData, setTableData] = useState([]);
  const [agentName, setAgentName] = useState("");
  const [agentContactNumber, setAgentContactNumber] = useState("");
  const [agentEmail, setAgentEmail] = useState("");
  const [agentRecordId, setAgentRecordId] = useState(0);
  const [row, setRow] = useState({});
  const [add, setAdd] = useState(false);
  const [saveEditModal, setSaveEditModal] = useState(false);
  const [saveAddModal, setSaveAddModal] = useState(false);
  const [deleteAgent, setDeleteAgent] = useState(false);
  const editPermission =
    OFFICE_PERMISSIONS.permission_office_agentofrecords_edit;
  const deletePermission =
    OFFICE_PERMISSIONS.permission_office_agentofrecords_delete;
  const addPermission = OFFICE_PERMISSIONS.permission_office_agentofrecords_add;
  const userPermissions = useRecoilValue(permissionsSelector);

  const { data: agentRecordData, isLoading: isFetching } = getAORs();
  useEffect(() => {
    if (agentRecordData) {
      setTableData(
        agentRecordData.map((x) => {
          return { ...x, edit: false };
        })
      );
    }
  }, [agentRecordData]);

  useEffect(() => {
    getAORs(officeId).then((res) =>
      setTableData(
        res.map((x) => {
          return { ...x, edit: false };
        })
      )
    );
  }, []);

  const Edit = (row) => {
    setAgentRecordId(row.agentRecordId);
    setRow(row);
    setTableData(
      tableData.map((x) => {
        if (x.agentRecordId === row.agentRecordId) x.edit = true;
        else x.edit = false;
        return x;
      })
    );
    setAgentName(row.agentName);
    setAgentEmail(row.agentEmail);
    setAgentContactNumber(row.agentContactNumber);
  };

  const Cancel = () => {
    setTableData(
      tableData.map((x) => {
        x.edit = false;
        return x;
      })
    );
    Reset();
  };

  const Reset = () => {
    setAgentName("");
    setAgentContactNumber("");
    setAgentEmail("");
    setAgentRecordId(0);
    setRow({});
  };

  const Update = () => {
    const data = {
      ...row,
      agentName,
      agentEmail,
      agentContactNumber,
    };

    if (
      data.agentName !== "" ||
      data.agentEmail !== "" ||
      data.agentContactNumber !== ""
    ) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(data.agentEmail) || data.agentEmail === "") {
        updateAgentRecord(data)
          .then((res) => {
            if (res.data === "Duplicate") {
              setSaveAddModal(false);
              toast.fire("Failed", "Agent of Record already exist.", "error");
            } else if (res.status === 200) {
              setSaveEditModal(false);
              Cancel();
              toast.fire(
                "Success",
                "Agent of Record updated successfully.",
                "success"
              );

              getAORs(officeId).then((res) =>
                setTableData(
                  res.map((x) => {
                    return { ...x, edit: false };
                  })
                )
              );
            }
          })
          .catch(() => {
            Cancel();
            toast.fire("Failed", "Failed to update Agent's Record.", "error");
          });
      } else {
        setSaveEditModal(false);
        toast.fire("Failed", "Invalid email format.", "error");
      }
    } else {
      setSaveEditModal(false);
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
    }
  };

  const Add = () => {
    const data = {
      officeId,
      agentName,
      agentEmail,
      agentContactNumber,
    };
    if (
      data.agentName !== "" ||
      data.agentEmail !== "" ||
      data.agentContactNumber !== ""
    ) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(data.agentEmail) || data.agentEmail === "") {
        addAgentRecord(data)
          .then((res) => {
            if (res.data === "Duplicate") {
              setSaveAddModal(false);
              toast.fire("Failed", "Agent of Record already exist.", "error");
            } else if (res.status === 200) {
              Cancel();
              setAdd(false);
              setSaveAddModal(false);
              toast.fire(
                "Success",
                "New Agent of Record added successfully",
                "success"
              );

              getAORs(officeId).then((res) =>
                setTableData(
                  res.map((x) => {
                    return { ...x, edit: false };
                  })
                )
              );
            }
          })
          .catch(() => {
            Cancel();
            toast.fire("Failed", "Failed to add new Agent's Record.", "error");
          });
      } else {
        setSaveAddModal(false);
        toast.fire("Failed", "Invalid email format.", "error");
      }
    } else {
      setSaveAddModal(false);
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
    }
  };

  const Delete = (id) => {
    deleteAgentRecord(id)
      .then(() => {
        Cancel();
        setDeleteAgent(false);
        toast.fire(
          "Success",
          "Agent of Record deleted successfully.",
          "success"
        );
        getAORs(officeId).then((res) =>
          setTableData(
            res.map((x) => {
              return { ...x, edit: false };
            })
          )
        );
      })
      .catch(() => {
        Cancel();
        toast.fire("Failed", "Failed to delete Agent's Record.", "error");
      });
  };

  var columns = [
    {
      name: "Agent Name",
      cell: (row) => {
        return (
          <div className="font-normal font-sans">
            {row.edit ? (
              <TextInput
                value={agentName}
                onChange={(e) => setAgentName(e.target.value)}
              />
            ) : (
              row.agentName
            )}
          </div>
        );
      },
      sortable: true,
      left: true,
    },
    {
      name: "Agent Contact Number",
      cell: (row) => {
        return (
          <div className="font-normal font-sans">
            {row.edit ? (
              <TextInput
                value={agentContactNumber}
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;

                  // if value is not blank, then test the regex

                  if (e.target.value === "" || re.test(e.target.value)) {
                    setAgentContactNumber(e.target.value);
                  }
                }}
              />
            ) : (
              row.agentContactNumber
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Agent Email",
      cell: (row) => {
        return (
          <div className="font-normal font-sans">
            {row.edit ? (
              <TextInput
                value={agentEmail}
                onChange={(e) => setAgentEmail(e.target.value)}
              />
            ) : (
              row.agentEmail
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Actions",
      center: true,

      cell: (row) => {
        return row.edit ? (
          <div className="flex gap-2">
            <SaveButton
              onClick={() => {
                if (
                  agentName === row?.agentName &&
                  agentContactNumber === row?.agentContactNumber &&
                  agentEmail === row?.agentEmail
                ) {
                  toast.fire(
                    "Saving Failed",
                    "No changes have been made.",
                    "warning"
                  );
                  setSaveEditModal(false);
                } else {
                  setSaveEditModal(true);
                }
              }}
            />
            <CancelButton onClick={Cancel} />
          </div>
        ) : userPermissions.includes(editPermission) ? (
          <div className="flex space-x-2">
            {userPermissions.includes(editPermission) ? (
              <EditButton
                className={
                  tableData.filter((x) => x.edit === true).length > 0 || add
                    ? "opacity-50"
                    : "opacity-100"
                }
                disabled={
                  tableData.filter((x) => x.edit === true).length > 0 || add
                }
                onClick={() => Edit(row)}
              />
            ) : (
              ""
            )}
            {userPermissions.includes(deletePermission) ? (
              <DeleteButton
                className={
                  tableData.filter((x) => x.edit === true).length > 0 || add
                    ? "opacity-50"
                    : "opacity-100"
                }
                disabled={
                  tableData.filter((x) => x.edit === true).length > 0 || add
                }
                onClick={() => {
                  setAgentRecordId(row.agentRecordId);
                  setDeleteAgent(true);
                }}
              />
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        );
      },
      sortable: true,
    },
  ];
  return (
    <>
      <div className="flex items-center">
        <ConfirmBoxModal
          ModalTitle="Update Agent of Record"
          qConfirmation=" Are you sure you want to save this?"
          isOpen={saveEditModal}
          onClose={() => setSaveEditModal(false)}
          onClickFunction={() => Update()}
        />

        <ConfirmBoxModal
          ModalTitle="Save Agent of Record"
          qConfirmation=" Are you sure you want to save this?"
          isOpen={saveAddModal}
          onClose={() => setSaveAddModal(false)}
          onClickFunction={() => Add()}
        />

        <ConfirmBoxDelete
          ModalTitle="Delete Agent of Record"
          qConfirmation=" Are you sure you want to save this?"
          isOpen={deleteAgent}
          onClose={() => setDeleteAgent(false)}
          onClickFunction={() => Delete(agentRecordId)}
        />
        {add ? "" : <div className=" text-sm text-primary font-bold"></div>}
        <div className="ml-auto mr-8">
          {add ? (
            ""
          ) : userPermissions.includes(addPermission) ? (
            <AddButton
              buttonText="Add"
              className={
                tableData.filter((x) => x.edit === true).length > 0
                  ? "opacity-50"
                  : "opacity-100"
              }
              disabled={tableData.filter((x) => x.edit === true).length > 0}
              onClick={() => {
                setAdd(true);
                Cancel();
              }}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      {add ? (
        <div className="p-4 my-4 mx-8 flex flex-col gap-y-3 bg-white box-shadow border-quinary border-l-2">
          <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
            <div className="text-base text-primary font-bold">
              Add Agent Record
            </div>
            <div className="flex justify-between gap-2">
              <SaveButton
                onClick={() => {
                  setSaveAddModal(true);
                }}
              />
              <CancelButton
                onClick={() => {
                  setAdd(false);
                  Reset();
                }}
              />
            </div>
          </div>
          <div className="h-1 w-full border-b-2 border-secondary -mt-2"></div>
          <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full">
            <div className="w-full grid grid-cols-3 items-center">
              <div className="flex justify-start space-x-1 text-right mr-2">
                <label className="block font-medium text-gray-700">
                  Agent Name:
                </label>
              </div>
              <div className="col-span-2">
                <TextInput
                  value={agentName}
                  placeholder="Agent Name"
                  onChange={(e) => setAgentName(e.target.value)}
                />
              </div>
            </div>
            <div className="w-full grid grid-cols-4 items-center">
              <div className="col-span-2 flex justify-start space-x-1 text-right mr-2">
                <label className="block font-medium text-gray-700">
                  Agent Contact Number:
                </label>
              </div>
              <div className="col-span-2">
                <TextInput
                  value={agentContactNumber}
                  placeholder="Agent Contact Number"
                  onChange={(e) => {
                    const re = /^[0-9\b]+$/;

                    // if value is not blank, then test the regex

                    if (e.target.value === "" || re.test(e.target.value)) {
                      setAgentContactNumber(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="w-full grid grid-cols-3 items-center">
              <div className="flex justify-start space-x-1 text-right mr-2">
                <label className="block font-medium text-gray-700">
                  Agent Email:
                </label>
              </div>
              <div className="col-span-2">
                <TextInput
                  value={agentEmail}
                  placeholder="Agent Email"
                  onChange={(e) => setAgentEmail(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* <div className="h-1 w-full mt-3  border-b-4 border-secondary"></div> */}
          <div className="px-8 w-full borderContainer pb-4 bg-white">
            <div className="mt-2"></div>
            <TableNoBorder
              columns={columns}
              data={tableData}
              isLoading={isFetching}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default AgentRecordTable;
